import { __awaiter, __generator } from "tslib";
import { isEqual } from 'lodash';
import { getAvailabilityState } from '@gn-audio/core/api/pricing/utilities';
import { fetchEcomSetting, fetchPriceDisplaySetting } from '@gn-audio/core/api/site-settings';
import { fetchPrice } from './utilities/fetch-price';
import { getDiscountStatus } from './utilities/get-discount-status';
import { getDiscountedPrice } from './utilities/get-discounted-price';
import { getFormattedDiscountedPrice } from './utilities/get-formatted-discounted-price';
import { getFormattedDiscountedPriceWithoutVat } from './utilities/get-formatted-discounted-price-without-vat';
import { getFormattedListedPrice } from './utilities/get-formatted-listed-price';
import { getFormattedListedPriceWithoutVat } from './utilities/get-formatted-listed-price-without-vat';
import { getListedPrice } from './utilities/get-listed-price';
var baseCssClass = 'product-price';
import comingSoonTemplate from './templates/coming-soon.template.html';
import includeExcludeVatThresholdTemplate from './templates/exclude-include-vat.template.html';
import excludeVatThresholdTemplate from './templates/exclude-vat-threshold.template.html';
import remarkTempalte from './templates/remark.template.html';
import simpleTemplate from './templates/simple.template.html';
export var PriceDirective = [
    '$compile',
    '$q',
    function ($compile, $q) {
        return {
            link: function ($scope, $element) {
                var innerEcomSetting;
                var displaySetting;
                $scope.empty = true;
                $scope.loading = true;
                var handlePrice = function (price) {
                    var html;
                    $element.empty();
                    $scope.empty = !Boolean(price);
                    $scope.price = price;
                    if (!$scope.price) {
                        if ($scope.onPriceLoaded) {
                            $scope.onPriceLoaded({ price: $scope.price });
                        }
                        return;
                    }
                    var listedPrice = getListedPrice(price);
                    var availabilityState = getAvailabilityState($scope.price);
                    if (availabilityState === 4 /* ComingSoon */) {
                        html = $compile(comingSoonTemplate)($scope);
                    }
                    else if (($scope.pType === "f" /* Family */ || availabilityState < 3 /* WhereToBuy */) && listedPrice) {
                        html = getPriceTemplate(price, $scope.accessoriesPrices, $scope.servicesPrices);
                    }
                    if (html !== undefined) {
                        if ($scope.withRemarkAsContent) {
                            $element.append(remarkTempalte);
                        }
                        if ($scope.withRemarkAsContent || $scope.withRemark) {
                            $element.find("." + baseCssClass)
                                .addClass(baseCssClass + "--remark");
                        }
                        $element.append(html);
                    }
                    if ($scope.onPriceLoaded) {
                        $scope.onPriceLoaded({ price: $scope.price });
                    }
                };
                var updateFromProduct = function () {
                    if (!$scope.pId || !(innerEcomSetting === null || innerEcomSetting === void 0 ? void 0 : innerEcomSetting.ecomEnabled)) {
                        handlePrice();
                        return;
                    }
                    $q.when(fetchPrice($scope.pId, $scope.pType, $scope.queryParameters))
                        .then(handlePrice)
                        .finally(function () { $scope.loading = false; });
                };
                var getPriceTemplate = function (price, accessoryPrices, servicesPrices) {
                    var html;
                    var isBusiness = $scope.segmentType === "Business" /* Business */;
                    var isConsumer = $scope.segmentType === "Consumer" /* Consumer */;
                    var discountedPrice = getDiscountedPrice(price);
                    $scope.isPriceDiscounted = getDiscountStatus(price, accessoryPrices, servicesPrices);
                    var thresholdPrice = displaySetting === null || displaySetting === void 0 ? void 0 : displaySetting.priceDisplayThreshold;
                    switch (true) {
                        case (displaySetting === null || displaySetting === void 0 ? void 0 : displaySetting.priceDisplayOption) === "ExcludeVATThreshold" /* ExcludeVATThreshold */ &&
                            (isBusiness || (thresholdPrice && discountedPrice && discountedPrice < thresholdPrice)):
                            setFormattedDiscountedPriceWithoutVat();
                            setFormattedListedPriceWithoutVat();
                            html = $compile(excludeVatThresholdTemplate)($scope);
                            break;
                        case (displaySetting === null || displaySetting === void 0 ? void 0 : displaySetting.priceDisplayOption) === "ExcludeIncludeVAT" /* ExcludeIncludeVAT */ && isBusiness:
                        case (displaySetting === null || displaySetting === void 0 ? void 0 : displaySetting.priceDisplayOption) === "IncludesVATLabel" /* IncludesVATLabel */ && (isBusiness || isConsumer):
                            setFormattedDiscountedPrice();
                            setFormattedDiscountedPriceWithoutVat();
                            setFormattedListedPrice();
                            setFormattedListedPriceWithoutVat();
                            html = $compile(includeExcludeVatThresholdTemplate)($scope);
                            break;
                        default:
                            setFormattedDiscountedPrice();
                            setFormattedListedPrice();
                            html = $compile(simpleTemplate)($scope);
                            break;
                    }
                    return html;
                };
                var setFormattedDiscountedPrice = function () {
                    $q.when(getFormattedDiscountedPrice($scope.price, $scope.servicesPrices, $scope.accessoriesPrices))
                        .then(function (formattedDiscountedPrice) {
                        $scope.formattedDiscountedPrice = formattedDiscountedPrice;
                    });
                };
                var setFormattedDiscountedPriceWithoutVat = function () {
                    $q.when(getFormattedDiscountedPriceWithoutVat($scope.price, $scope.servicesPrices, $scope.accessoriesPrices))
                        .then(function (formattedDiscountedPriceWithoutVat) {
                        $scope.formattedDiscountedPriceWithoutVat = formattedDiscountedPriceWithoutVat;
                    });
                };
                var setFormattedListedPrice = function () {
                    $q.when(getFormattedListedPrice($scope.price, $scope.servicesPrices, $scope.accessoriesPrices))
                        .then(function (formattedListedPrice) {
                        $scope.formattedListedPrice = formattedListedPrice;
                    });
                };
                var setFormattedListedPriceWithoutVat = function () {
                    $q.when(getFormattedListedPriceWithoutVat($scope.price, $scope.servicesPrices, $scope.accessoriesPrices))
                        .then(function (formattedListedPriceWithoutVat) {
                        $scope.formattedListedPriceWithoutVat = formattedListedPriceWithoutVat;
                    });
                };
                var productIdWatcher;
                var accessoriesPricesWatcher;
                var servicesPriceWatcher;
                $q.when(fetchEcomSetting())
                    .then(function (ecomSetting) { innerEcomSetting = ecomSetting; })
                    .finally(function () {
                    if (!(innerEcomSetting === null || innerEcomSetting === void 0 ? void 0 : innerEcomSetting.ecomEnabled)) {
                        return;
                    }
                    $q.when(fetchPriceDisplaySetting())
                        .then(function (priceDisplaySetting) { displaySetting = priceDisplaySetting; })
                        .finally(function () {
                        if (!isNaN($scope.pId)) {
                            updateFromProduct();
                        }
                        productIdWatcher = $scope.$watch('pId', function (newValue, oldValue) {
                            if (newValue === oldValue) {
                                return;
                            }
                            updateFromProduct();
                        });
                        accessoriesPricesWatcher = $scope.$watch('accessoriesPrices', function (newValue, oldValue) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (isEqual(newValue, oldValue)) {
                                    return [2 /*return*/];
                                }
                                updateFromProduct();
                                return [2 /*return*/];
                            });
                        }); });
                        servicesPriceWatcher = $scope.$watch('servicesPrices', function (newValue, oldValue) { return __awaiter(void 0, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                if (!isEqual(newValue, oldValue)) {
                                    updateFromProduct();
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        $scope.$on('$destroy', function () {
                            productIdWatcher();
                            accessoriesPricesWatcher();
                            servicesPriceWatcher();
                        });
                    });
                });
            },
            restrict: 'E',
            scope: {
                onPriceLoaded: '&?',
                pId: '<',
                pType: '@',
                accessoriesPrices: '<?',
                servicesPrices: '<?',
                segmentType: '<?',
                withRemark: '@?',
                withRemarkAsContent: '@?',
                queryParameters: '<?'
            },
        };
    },
];
